import dataRepository from './dataRepository'
import { LOCAL_STORAGE } from './constants/localStorage'

export const setRouteParams = (params: Record<string, any>) => {
  const values = JSON.stringify(Object.values(params))
  dataRepository.setData(LOCAL_STORAGE.PARAMS, values)
}
